(() => {
  'use strict';
  const formId = 'RRmJ6B';
  const tab = document.querySelector('[data-bff-welcome-tab]');
  if (!tab) return;
  const suppressed=()=>tab.dataset.pageType==='product' && window.matchMedia('(max-width:767px)').matches;
  const seenKey = 'bff_welcome_seen_v1';
  const doneKey = 'bff_welcome_submitted_v1';
  const read = key => {try{return localStorage.getItem(key)==='1';}catch{return false;}};
  const write = key => {try{localStorage.setItem(key,'1');}catch{}};
  let seen=read(seenKey), submitted=read(doneKey), opening=false, open=false;
  const update=()=>{tab.hidden=suppressed() || open || submitted || !seen;};
  const requestOpen=()=>{
    if(suppressed() || open || opening || submitted)return;
    opening=true;seen=true;write(seenKey);update();
    window._klOnsite=window._klOnsite||[];
    window._klOnsite.push(['openForm',formId]);
    // If a visitor blocks the form provider, retain the small retry control.
    setTimeout(()=>{if(!open){opening=false;update();}},10000);
  };
  const closeUnexpected=()=>{
    const form=document.querySelector('[data-testid="klaviyo-form-'+formId+'"]');
    form?.closest('[role="dialog"]')?.querySelector('button[aria-label="Close dialog"]')?.click();
  };
  window.addEventListener('klaviyoForms',event=>{
    if(event.detail?.formId!==formId)return;
    const type=event.detail.type;
    if(type==='open'){
      if(suppressed()){setTimeout(closeUnexpected,0);return;}
      if(open && !submitted)return;
      if((seen && !opening) || submitted){setTimeout(closeUnexpected,0);return;}
      open=true;opening=false;seen=true;write(seenKey);
    } else if(type==='close'){
      open=false;opening=false;seen=true;write(seenKey);
    } else if(type==='submit'){
      submitted=true;write(doneKey);
    }
    update();
  });
  // A dismissed Klaviyo form can retain its transparent, fixed overlay.
  // Release only our closing welcome form; keep active forms interactive.
  const reconcileWelcomeOverlay=()=>{
    const form=document.querySelector('[data-testid="klaviyo-form-'+formId+'"]');
    const dialog=form?.closest('[role="dialog"]');
    if(!dialog)return;
    const closing=getComputedStyle(dialog).animationName.includes('klaviyo-fadeout');
    if(closing && !dialog.hasAttribute('data-bff-dismissed')){
      dialog.setAttribute('data-bff-dismissed','');
      dialog.inert=true;
      dialog.setAttribute('aria-hidden','true');
      dialog.style.pointerEvents='none';
    } else if(!closing && dialog.hasAttribute('data-bff-dismissed')){
      dialog.removeAttribute('data-bff-dismissed');
      dialog.inert=false;
      dialog.removeAttribute('aria-hidden');
      dialog.style.removeProperty('pointer-events');
    }
    if(closing){
      const active=[...document.querySelectorAll('[data-kl-scroll-locking-modal="true"]')].some(el=>{
        const style=getComputedStyle(el);
        return !style.animationName.includes('klaviyo-fadeout') && style.display!=='none' && style.visibility!=='hidden';
      });
      if(!active)document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  };
  let overlayCheckPending=false;
  const scheduleOverlayCheck=()=>{
    if(overlayCheckPending)return;
    overlayCheckPending=true;
    requestAnimationFrame(()=>{overlayCheckPending=false;reconcileWelcomeOverlay();});
  };
  new MutationObserver(scheduleOverlayCheck).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
  window.addEventListener('pageshow',scheduleOverlayCheck);
  window.addEventListener('klaviyoForms',scheduleOverlayCheck);
  scheduleOverlayCheck();
  tab.addEventListener('click',requestOpen);
  update();
  if(!seen && !submitted){
    const firstVisit=()=>setTimeout(requestOpen,700);
    if(document.readyState==='complete')firstVisit();
    else window.addEventListener('load',firstVisit,{once:true});
  }
})();
